import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CompaniesService } from '@services/companies.service';
import { enumUserBetaFlag } from '@data-layer/enums/user';
import { UserBetaFlagModel } from '@data-layer/models/user';

@Directive({
  selector: '[hasFeature]',
})
export class HasFeatureDirective implements OnInit {
  private feature: enumUserBetaFlag;
  private elseTemplateRef: TemplateRef<any> | null = null;

  @Input()
  set hasFeature(feature: enumUserBetaFlag) {
    this.feature = feature;
  }
  @Input()
  set hasFeatureElse(templateRef: TemplateRef<any> | null) {
    this.elseTemplateRef = templateRef;
  }

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private companiesService: CompaniesService) {}

  public ngOnInit(): void {
    this.toggleView(!!this.companiesService.getAllUserBetaFlags().find((item: UserBetaFlagModel) => item.tag === this.feature));
  }

  private toggleView(enabled: boolean): void {
    if (enabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      if (this.elseTemplateRef) {
        this.viewContainer.createEmbeddedView(this.elseTemplateRef);
      } else {
        this.viewContainer.clear();
      }
    }
    this.elseTemplateRef = null;
  }
}
